export const balancePagiation = {
  namespaced: true,
  state: () => ({
    paginationBalanceStateParams: {
      count: 0,
      limit: 14,
      total: 0,
      page: 0
    }
  }),

  getters: {
    numPages: (state) =>
      Math.ceil(
        state.paginationBalanceStateParams.total /
          state.paginationBalanceStateParams.limit
      )
  },
  mutations: {
    update_pagination(state, { total, count, limit, page }) {
      state.paginationBalanceStateParams = { total, count, limit, page }
    }
  },
  actions: {
    getBalanceAll({ commit }, pagination) {
      commit('update_pagination', pagination)
    }
  }
}
